

import React from 'react';

import {Header, Table, Checkbox, Input} from 'semantic-ui-react';


export class PropertiesTable extends React.Component {


  constructor(props) {
    super(props);

    this.state = {
      counter: 1
    };

    this.onPropertyChanged = this.onPropertyChanged.bind(this);
  }


  onPropertyChanged(propName, newValue) {

    let newState = {};
    newState[propName] = newValue;

    this.props.interactive.setState(newState);

    let newCounter = this.state.counter + 1;
    this.setState({counter: newCounter});
  }

  
  render() {
    
    let content = [];

    if (this.props.manifest !== undefined) {

      let s = this.props.interactive.getState();

      // For now, assuming all first level objects in manifest.properties are groups,
      //  and all child objects of groups are properties. TODO: fix

      let groups = this.props.manifest.properties;

      for (let i = 0; i < groups.length; ++i) {

        let propRows = [];

        let objs = groups[i].objects;

        for (let j = 0; j < objs.length; ++j) {
          let obj = objs[j];

          let control = {};

          if (obj.propType === 'boolean') {
            control = (
              <Checkbox
                toggle
                checked={s[obj.propName]}
                onChange={() => this.onPropertyChanged(obj.propName, !s[obj.propName])}
              />
            );
          } else if (obj.propType === 'range') {
            control = (
              <Input
                min={obj.minValue}
                max={obj.maxValue}
                step='0.001'
                type='range'
                value={s[obj.propName]}
                onChange={(e) => this.onPropertyChanged(obj.propName, e.target.value)}
              />
            );
          }

          propRows.push(
            <Table.Row key={obj.propName}>
              <Table.Cell>{obj.label}</Table.Cell>
              <Table.Cell textAlign='right'>{control}</Table.Cell>
            </Table.Row>
          );
        }
        
        content.push(
          <Table key={i} compact>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell colSpan='2'>{groups[i].name}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {propRows}
            </Table.Body>
          </Table>
        );
      }

    }


    return (
      <div>
        {content}
      </div>
    );

  }


}


